<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit" ref="addIssue" id="addIssue">
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-textarea
                        label="Issue Type"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="issue_type.value.value"
                        :error-messages="issue_type.errorMessage.value"
                        autocomplete="off"
                        rows="1"
                        clearable
                      ></v-textarea>

                      <v-textarea
                        label="Product Issue Number"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="product_issue_no.value.value"
                        :error-messages="product_issue_no.errorMessage.value"
                        autocomplete="off"
                        rows="1"
                        clearable
                      ></v-textarea>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Issue Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="issue_date.value.value"
                        :error-messages="issue_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Warehouse
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="purpose_id.value.value"
                        :items="getPurposeList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="purpose_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Purpose
                          <span class="text-red-accent-4"></span>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        label="Requsition By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="issue_by.value.value"
                        :error-messages="issue_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Requsition By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="issue_by_mobile.value.value"
                        :error-messages="issue_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Requsition By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="issue_by_email.value.value"
                        :error-messages="issue_by_email.errorMessage.value"
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Item Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit" ref="addIssue" id="addIssue">
                  <v-row class="pt-2 justify-center">
                    <v-col cols="8">
                      <v-autocomplete
                        label="Search Prdouct Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>

                      <input
                        v-model="issue_masters_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                    <!-- <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col> -->
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                        style="height: 40vh; overflow-y: scroll"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 5%">SL</th>
                            <th class="text-left" style="width: 15%">
                              Code
                            </th>
                            <th class="text-left" style="width: 25%">
                              Product Name
                            </th>
                            <th class="text-center" style="width: 15%">
                              Quantity
                            </th>
                            <th class="text-center" style="width: 15%">Unit</th>
                            <th class="d-none" style="width: 15%">Rate</th>
                            <th class="text-right d-none" style="width: 15%">
                              Sub Total
                            </th>
                            <th class="text-center" style="width: 10%">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_code }}
                            </td>
                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_name }}
                            </td>
                            <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                type="number"
                                style="width: 80px;"
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                :error-messages="
                                  item.qty < 1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.rate
                                "
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>
                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>
                            <td class="text-right py-1 d-none">
                                <v-text-field
                                  :reverse="false"
                                  controlVariant="stacked"
                                  style="width:100px;"
                                  label=""
                                  :hideInput="false"
                                  :inset="false"
                                  :min="1"
                                  type="number"
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  v-model="item.rate"
                                  hide-details
                                  :error="item.rate < 1"
                                  :error-messages=" item.qty < 1 ? 'rate must be greater than 0' : '' "
                                  @update:model-value=" item.total = item.qty * item.rate "
                                ></v-text-field>
                            </td>
                            <td class="text-right py-1 d-none">
                              {{ this.$numberFormat(item.total) }}
                            </td>
                            <td class="text-center py-1">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="6" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="6" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8">
                        <v-textarea
                          label="Description"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                              class="bg-grey-darken-1 me-2"
                              variant="flat"
                              @click="submitForm(0)"
                              >DRAFT</v-btn
                          >
                          <v-btn
                              class="bg-primary"
                              variant="flat"
                              @click="submitForm(1)"
                              >POST</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }
    if (this.$store.getters.getPurposeList.length === 0) {
      this.$store.dispatch("getPurposeList");
    }
    if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    }
  },
  computed: {
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getPurposeList() {
      return this.$store.getters.getPurposeList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.$store.getters.getAuthUser.branch_id && item.status == 1
      );
    },
  },
  methods: {
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_code: product.code,
        product_name: product.name,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        rate: product.purchase_rate,
        total: product.purchase_rate,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        issue_date: yup.date().nullable().label("Issue Date"),
        warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
      }),
    });

    const issue_date = useField("issue_date");
    const product_id = useField("product_id");
    const pr_status = useField("pr_status");
    const status = useField("status");
    const employee_id = useField("employee_id");
    const product_issue_no = useField("product_issue_no");
    const warehouse_id = useField("warehouse_id");
    const purpose_id = useField("purpose_id");
    const issue_masters_id = useField("issue_masters_id");

    const issue_type = useField("issue_type");
    const remarks = useField("remarks");
    const issue_by = useField("issue_by");
    const issue_by_mobile = useField("issue_by_mobile");
    const issue_by_email = useField("issue_by_email");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();
    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      values.cart = cart.value;
      store
        .dispatch("saveUpdateInvIssue", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "issue-record" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      submitForm,
      product_id,
      issue_date,
      remarks,
      issue_type,
      cart,
      issue_by,
      issue_by_mobile,
      issue_by_email,
      pr_status,
      status,
      errorMessages,
      employee_id,
      product_issue_no,
      warehouse_id,
      purpose_id,
      issue_masters_id,
      buttonText,
      loading,
    };
  },
  mounted() {
    this.pr_status.value.value = "1";
    this.status.value.value = 1;
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.issue_by.value.value = this.$store.getters.getAuthUser.full_name;
    this.issue_by_mobile.value.value = this.$store.getters.getAuthUser.mobile;
    this.issue_by_email.value.value = this.$store.getters.getAuthUser.email;

    // Set issue_date to today
    const today = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
    this.issue_date.value.value = today;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getInvIssueById", id)
          .then((data) => {
            this.isEntryMode = false;
            let requisition = data;
            this.issue_masters_id.value.value = requisition.id;
            this.issue_type.value.value = requisition.issue_type || "";
            this.product_issue_no.value.value =
              requisition.product_issue_no || "";
            this.issue_by.value.value = requisition.issue_by || user.full_name;
            this.issue_by_mobile.value.value =
              requisition.issue_by_mobile || user.mobile;
            this.issue_by_email.value.value =
              requisition.issue_by_email || user.email;
            this.pr_status.value.value = requisition.pr_status || "1";
            this.status.value.value = requisition.status || 1;
            this.employee_id.value.value = requisition.employee_id || "";
            this.issue_date.value.value = requisition.issue_date
              ? new Date(requisition.issue_date)
              : new Date();
            this.warehouse_id.value.value = requisition.warehouse.id;
            this.purpose_id.value.value = requisition?.purpose_id;
            this.product_id.value.value = null;
            this.cart.value = [];

            // Insert items one by one
            (requisition.inv_requisition_details || []).forEach((item) => {
              this.cart.push({
                product_id: item?.product_id,
                product_code: item?.product?.code || "",
                product_name: item?.product?.name || "",
                qty: item.qty,
                unit_id: item?.product?.unit?.id || "",
                unit_name: item?.product?.unit?.name || "",
                rate: item?.rate,
                total: item?.qty * item?.rate,
              });
            });
            this.remarks.value.value = requisition.remarks
              ? requisition.remarks
              : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch requisition:", error);
          });
      });
    } else {
      this.issue_masters_id.value.value = "";
      this.issue_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
